/**
 * Authenticity Guaranteed — Interactive Components
 * Scoped to .ag-* elements only. No global side effects.
 */
(function () {
  'use strict';

  /* =====================================================================
     FAQ ACCORDION
     ===================================================================== */
  function initFaqAccordion(section) {
    if (!section) return;
    var items = section.querySelectorAll('.ag-faq__item');
    if (!items.length) return;

    var singleOpen = section.getAttribute('data-single-open') === 'true';

    items.forEach(function (item, index) {
      var btn = item.querySelector('.ag-faq__question');
      var answer = item.querySelector('.ag-faq__answer');
      if (!btn || !answer) return;

      // Ensure stable unique ID for accessibility
      var answerId = btn.getAttribute('aria-controls') || ('ag-faq-ans-' + index + '-' + Math.random().toString(36).substr(2, 6));
      answer.setAttribute('id', answerId);
      btn.setAttribute('aria-controls', answerId);
      answer.setAttribute('role', 'region');

      var isInitialOpen = item.getAttribute('data-open') === 'true';
      btn.setAttribute('aria-expanded', isInitialOpen ? 'true' : 'false');

      // Remove any previous listener to avoid duplicate bindings
      var newBtn = btn.cloneNode(true);
      btn.parentNode.replaceChild(newBtn, btn);

      newBtn.addEventListener('click', function (e) {
        e.preventDefault();
        var isOpen = item.getAttribute('data-open') === 'true';
        var nextState = !isOpen;

        if (singleOpen && nextState) {
          items.forEach(function (other) {
            if (other !== item && other.getAttribute('data-open') === 'true') {
              other.setAttribute('data-open', 'false');
              var otherBtn = other.querySelector('.ag-faq__question');
              if (otherBtn) otherBtn.setAttribute('aria-expanded', 'false');
            }
          });
        }

        item.setAttribute('data-open', nextState ? 'true' : 'false');
        newBtn.setAttribute('aria-expanded', nextState ? 'true' : 'false');
      });
    });
  }

  /* =====================================================================
     INITIALIZE ON DOM READY
     ===================================================================== */
  function init() {
    document.querySelectorAll('.ag-faq').forEach(initFaqAccordion);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Shopify Theme Editor support (re-init on section change)
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      if (e.target) {
        var faq = e.target.querySelector('.ag-faq');
        if (faq) initFaqAccordion(faq);
      }
    });
  }
})();
